var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('h1',{class:_vm.darkMode
            ? 'app-title-dark mr-1'
            : 'app-title mr-1'},[_vm._v(_vm._s(_vm.title))]),_c('h1',{class:_vm.darkMode
            ? 'app-subtitle-dark mr-1'
            : 'app-subtitle mr-1'},[_vm._v(" "+_vm._s(_vm.subTitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }